import React, { useCallback, useEffect, useState } from 'react'
import './../invoice.css'
// import logo from './logokk.jpg'

import db from '../../../resources/db';
import { IonPage, IonHeader, IonTitle, IonToolbar, IonContent, IonButtons, IonBackButton, IonAlert } from '@ionic/react';
import invoicePatternGST from './../InvoicePatternGST';
import invoicePattern from './../InvoicePattern';
import { IonButton } from '@ionic/react';
import { IonIcon } from '@ionic/react';
import { create } from 'ionicons/icons';
import { IonLabel } from '@ionic/react';
import ShowInvPattern from './ShowInvPattern';
import ShowInvPatternGST from './ShowInvPatternGST';
import { APPLINKS } from '../../../resources/AppConst';

let inv = {
    id: 0,
    companyName: null,
    companyAddres: null,
    companyContact: null,
    gstEnabled: false,
    gst: null,
    customerName: null,
    customerDetails: null,
    invoiceNo: null,
    billDate: null,
    products: [],
    subtotalAmt: 0,
    totalAmt: 0,
}

const ShowInvoice = (props) => {

    const [invoiceData, setInvoiceData] = useState(inv)
    const [showAlert, setShowAlert] = useState(false);

    const clearAll = () => {
        setInvoiceData(inv)
    }

    const run = useCallback(async () => {
        const id = parseInt(props.match.params.id);
        await db.invoices.get({ "id": id }).then((res) => {
            setInvoiceData(res);
            setShowAlert(true);

            if (res) {
                let printDoc = document.getElementById('print').contentWindow;
                res.gstEnabled ?
                    printDoc.document.write(invoicePatternGST(res))
                    : printDoc.document.write(invoicePattern(res))
                printDoc.document.close();
            }
        })
    } , [props])

    useEffect(() => {
        run();
        return () => {
            clearAll();
        }
    }, [run])


    const print = () => {
        let print = document.getElementById('print').contentWindow;
        print.focus();
        print.print();
    }

    const editBill = (invoice) => {
        const url = `${APPLINKS.edit}/${invoiceData.id}`;
        props.history.push(url)
    }

    if (!invoiceData) {
        return (
            <IonAlert
                isOpen={showAlert}
                onDidDismiss={() => {
                    setShowAlert(false);
                    props.history.goBack()
                }}
                header={'This bill does not exist.'}
                subHeader={'Going back to Ledger'}
                buttons={['OK']}
            />
        )
    }
    const { invoiceNo } = invoiceData
    return (
        <IonPage>
            <IonHeader>

                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton />
                    </IonButtons>
                    <IonButtons slot='end'>
                        <IonButton onClick={editBill}>
                            <IonIcon icon={create}></IonIcon>
                            <IonLabel>Edit</IonLabel>
                        </IonButton>
                        <IonButton onClick={print} >
                            <IonIcon icon={print}></IonIcon>
                            <IonLabel>Print</IonLabel>

                        </IonButton>
                    </IonButtons>
                    <IonTitle>Invoice - {invoiceNo}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className='ion-padding' >
                <div className="div" style={{ }}>
                    {invoiceData.gstEnabled ? 
                        <ShowInvPatternGST invoice={invoiceData} />
                        : <ShowInvPattern invoice={invoiceData} />
                    }
                    <iframe style={{ display: "inline-block", border: 'none' }} className='ion-hide' width='90%' id='print' title='Print Invoice'></iframe>
                </div>
            </IonContent>

        </IonPage>
    )
}

export default ShowInvoice
